export default {
    methods: {
        getRowValue(row, config) {
            var data = config?.field?.split('.');
            data?.forEach(field => {
                try {
                    row = row[field];
                }
                catch {
                    return "";
                }
            });
            if (this.isDateColumn(config)) {
                return this.formatDateTime(row);
            }
            
            return row;
        },
        isDateColumn(config) {
            var field = config?.field ?? "";
            return config?.isDate
                || config?.type === "date"
                || config?.type === "datetime"
                || field === "createdOn"
                || field === "modifiedOn"
                || field.toLowerCase().endsWith("date");
        },
        formatDateTime(value) {
            if (!value) {
                return "";
            }

            var date = new Date(value);
            if (isNaN(date.getTime())) {
                return value;
            }

            return new Intl.DateTimeFormat("uk-UA", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hourCycle: "h23"
            }).format(date);
        },
        routerOpen(id, name){
            if(name){
                var routeData =  this.$router.resolve({ name: name, params: { id: id }});
                window.open(routeData.href, '_blank');
            }  
        },
        router(id, name) {
            if(name){
                this.$router.push({ name: name, params: { id: id }});
            }
        },
    },
}
